"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathUtils = void 0;
/**
 * Math utilities
 */
var MathUtils;
(function (MathUtils) {
    function round(num, precision = 0) {
        const precisionFactor = Math.pow(10, precision);
        return Math.round(num * precisionFactor) / precisionFactor;
    }
    MathUtils.round = round;
    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }
    MathUtils.deg2rad = deg2rad;
    function computeDistance(fromLat, fromLng, toLat, toLng) {
        const earthRadius = 6371; // Radius of the earth in km
        const dLat = deg2rad(toLat - fromLat); // deg2rad below
        const dLon = deg2rad(toLng - fromLng);
        const a = (Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(fromLat)) * Math.cos(deg2rad(toLat)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2));
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = earthRadius * c; // Distance in km
        return d;
    }
    MathUtils.computeDistance = computeDistance;
})(MathUtils = exports.MathUtils || (exports.MathUtils = {}));
//# sourceMappingURL=math.js.map